/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({
    page,
    actionType,
    resourceType,
    userId,
    since,
    until: untilDate,
  } = {}) {
    const params = { page };
    if (actionType) params.action_type = actionType;
    if (resourceType) params.resource_type = resourceType;
    if (userId) params.user_id = userId;
    if (since) params.since = since;
    if (untilDate) params.until = untilDate;
    return axios.get(this.url, { params });
  }

  exportCsv({
    actionType,
    resourceType,
    userId,
    since,
    until: untilDate,
  } = {}) {
    const params = { format: 'csv' };
    if (actionType) params.action_type = actionType;
    if (resourceType) params.resource_type = resourceType;
    if (userId) params.user_id = userId;
    if (since) params.since = since;
    if (untilDate) params.until = untilDate;
    return axios.get(this.url, { params, responseType: 'blob' });
  }
}

export default new AuditLogs();
